import { createAction, props } from '@ngrx/store';
import { IThread } from '../../../interfaces/living-lab/IThread';
import { IThreadComment, IThreadReply } from '../../../interfaces/living-lab/IThreadComment';

export const createThread = createAction(
  '[LivingLab] Create Thread',
  props<{
    content: string;
    vectorUUID: string;
    geometry: Array<number>;
    project_uuid: string;
  }>()
);

export const createThreadSuccess = createAction(
  '[LivingLab] Create Thread Success',
  props<({ project_uuid: string })>()
);

export const createThreadFailure = createAction(
  '[LivingLab] Create Thread Failure',
  props<{ error: any }>()
);

export const loadThreads = createAction(
  '[LivingLab] Load Threads',
  props<{ project_uuid: string }>()
);

export const loadThreadsSuccess = createAction(
  '[LivingLab] Load Threads Success',
  props<{ threads: Array<IThread> }>()
);

export const loadThreadsFailure = createAction(
  '[LivingLab] Load Threads Failure',
  props<{ error: any }>()
);

export const loadThreadComments = createAction(
  '[LivingLab] Load Thread Comments',
  props<{ thread_uuid: string }>()
);

export const loadThreadCommentsSuccess = createAction(
  '[LivingLab] Load Thread Comments Success',
  props<{ comments: Array<IThreadComment> }>()
);

export const loadThreadCommentsFailure = createAction(
  '[LivingLab] Load Thread Comments Failure',
  props<{ error: any }>()
);

// Realtime append-only updates
export const appendThreadComment = createAction(
  '[LivingLab] Append Thread Comment',
  props<{ comment: IThreadComment }>()
);

export const appendThreadReply = createAction(
  '[LivingLab] Append Thread Reply',
  props<{ reply: IThreadReply }>()
);

export const sendComment = createAction(
  '[LivingLab] Send Comment',
  props<{ content: string; thread_uuid: string;}>()
);

export const sendCommentSuccess = createAction(
  '[LivingLab] Send Comment Success'
);

export const sendCommentFailure = createAction(
  '[LivingLab] Send Comment Failure',
  props<{ error: any }>()
);


export const sendReply = createAction(
  '[LivingLab] Send Reply',
  props<{ content: string; comment_uuid: string;  thread_uuid: string;}>()
);

export const sendReplySuccess = createAction(
  '[LivingLab] Send Reply Success',
  props<{ thread_uuid: string }>()
);

export const sendReplyFailure = createAction(
  '[LivingLab] Send Reply Failure',
  props<{ error: any }>()
);